var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useCallback, useMemo } from "react";
import { Box, makeStyles } from "@material-ui/core";
import DayPicker from "react-day-picker";
import { typography } from "../../shared/theme";
import { ChevronIcon, ClearIcon } from "../icons";
import { FTLIconButton } from "../FTLIconButton";
import { FTLTypography } from "../FTLTypography";
import { Popper } from "@material-ui/core";
import { useClickOutside, FTLDateUtils } from "ftl-dashboards-core";
import Select, { components } from "react-select";
import { FTLLabel } from "../FTLLabel";
import { defaultSelectStyles } from "../FTLSelect";
const fromMonthDefault = new Date(FTLDateUtils.currentYear - 5, 0);
const toMonthDefault = new Date(FTLDateUtils.currentYear + 5, 0);
const months = FTLDateUtils.months;
const monthComponents = months.map((month, i) => (React.createElement("option", { key: month, value: i }, month)));
const YearMonthForm = ({ date, onChange, toMonth, fromMonth, }) => {
    const yearsComponents = useMemo(() => {
        const yearsComponents = [];
        for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
            yearsComponents.push(React.createElement("option", { key: i, value: i }, i));
        }
        return yearsComponents;
    }, [toMonth, fromMonth]);
    const handleChange = useCallback((e) => {
        if (e.target.form) {
            const { year, month } = e.target.form;
            onChange(new Date(year.value, month.value));
        }
    }, [onChange]);
    return (React.createElement("form", { className: "DayPicker-Caption" },
        React.createElement(Box, { display: "inline-flex", alignItems: "center", position: "relative", mr: 4 },
            React.createElement("select", { name: "month", onChange: handleChange, value: date.getMonth() }, monthComponents),
            React.createElement(ChevronIcon, { color: "secondary" })),
        React.createElement(Box, { display: "inline-flex", alignItems: "center", position: "relative" },
            React.createElement("select", { name: "year", onChange: handleChange, value: date.getFullYear() }, yearsComponents),
            React.createElement(ChevronIcon, { color: "secondary" }))));
};
export const FTLDayPicker = (_a) => {
    var { locale = "ru", months = FTLDateUtils.months, weekdaysLong = FTLDateUtils.weekdaysLong, weekdaysShort = FTLDateUtils.weekdaysShort, firstDayOfWeek = 1, showOutsideDays = true, className = "", popperPlacement = "top-start", placeholder = "Выберите дату", label, required, value, isDisabled, isError, isInline, isFormattingValue = true, BoxProps, selectedDays, menuWidth = 312, onDayClick, onClear, onClick, fromMonth = fromMonthDefault, toMonth = toMonthDefault } = _a, otherProps = __rest(_a, ["locale", "months", "weekdaysLong", "weekdaysShort", "firstDayOfWeek", "showOutsideDays", "className", "popperPlacement", "placeholder", "label", "required", "value", "isDisabled", "isError", "isInline", "isFormattingValue", "BoxProps", "selectedDays", "menuWidth", "onDayClick", "onClear", "onClick", "fromMonth", "toMonth"]);
    const classes = useStyles({ isRange: Array.isArray(selectedDays) });
    const [month, setMonth] = useState();
    const containerRef = useRef(null);
    const popperRef = useRef(null);
    const controlRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleClickOutside = useCallback((e) => {
        if (controlRef.current !== e.target)
            setIsMenuOpen(false);
    }, []);
    useClickOutside(popperRef, handleClickOutside);
    return (React.createElement(React.Fragment, null, !isInline && (React.createElement(Box, Object.assign({ width: "100%" }, BoxProps),
        label && React.createElement(FTLLabel, { label: label, required: required }),
        React.createElement("div", { ref: containerRef, onClick: onClick },
            React.createElement(Select, { placeholder: placeholder, styles: defaultSelectStyles("default", isError, false, isMenuOpen, isDisabled, false), isDisabled: isDisabled, isFocused: isMenuOpen, menuIsOpen: isMenuOpen, isSearchable: false, isClearable: Boolean(onClear), isMulti: false, isError: isError, value: value
                    ? {
                        label: isFormattingValue
                            ? FTLDateUtils.format(value, {
                                showHours: false,
                            })
                            : value instanceof Date
                                ? value.toString()
                                : value,
                    }
                    : null, onChange: (data, meta) => {
                    if (meta.action === "clear") {
                        onClear && onClear();
                    }
                }, components: {
                    Control: (props) => {
                        return (React.createElement(components.Control, Object.assign({}, props, { innerProps: {
                                onMouseDown: (e) => {
                                    props.innerProps.onMouseDown &&
                                        props.innerProps.onMouseDown(e);
                                    if (e.button === 0 && !isDisabled) {
                                        controlRef.current = e.target;
                                        setIsMenuOpen((val) => !val);
                                    }
                                },
                            } })));
                    },
                    Menu: (_a) => {
                        var { children } = _a, otherPropsMenu = __rest(_a, ["children"]);
                        return (React.createElement(Popper, { ref: popperRef, open: true, anchorEl: containerRef.current, placement: popperPlacement, style: Object.assign(Object.assign({}, otherPropsMenu.getStyles("menu", otherPropsMenu)), { width: menuWidth, position: isInline ? "initial" : "fixed" }), disablePortal: isInline },
                            React.createElement(DayPicker, Object.assign({ className: className + " " + classes.root, locale: locale, months: months, weekdaysLong: weekdaysLong, weekdaysShort: weekdaysShort, firstDayOfWeek: 1, showOutsideDays: true, month: month, fromMonth: fromMonthDefault, toMonth: toMonthDefault, selectedDays: selectedDays, captionElement: React.createElement(React.Fragment, null), onDayClick: (day, modifiers, e) => {
                                    if (!Array.isArray(selectedDays))
                                        setIsMenuOpen(false);
                                    onDayClick && onDayClick(day, modifiers, e);
                                }, navbarElement: ({ month, onPreviousClick, onNextClick, }) => {
                                    return (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                                        React.createElement(FTLIconButton, { onClick: () => onPreviousClick() },
                                            React.createElement(ChevronIcon, { direction: "left", color: "tertiary" })),
                                        React.createElement(YearMonthForm, { date: month, onChange: setMonth, toMonth: toMonth, fromMonth: fromMonth }),
                                        React.createElement(FTLIconButton, { onClick: () => onNextClick() },
                                            React.createElement(ChevronIcon, { direction: "right", color: "tertiary" }))));
                                }, weekdayElement: ({ weekday }) => (React.createElement(FTLTypography, { color: "tertiary", variant: "h5", className: classes.weekday }, weekdaysShort[weekday])), renderDay: (date) => {
                                    return (React.createElement(FTLTypography, { variant: "buttonTextSecondary" }, date.getDate()));
                                } }, otherProps))));
                    },
                    DropdownIndicator: (props) => {
                        return (React.createElement(components.DropdownIndicator, Object.assign({}, props),
                            React.createElement(ChevronIcon, null)));
                    },
                    IndicatorSeparator: () => null,
                    ClearIndicator: (props) => {
                        return (React.createElement(components.ClearIndicator, Object.assign({}, props),
                            React.createElement(FTLIconButton, { size: "small" },
                                React.createElement(ClearIcon, null))));
                    },
                } }))))));
};
const useStyles = makeStyles((theme) => ({
    root: ({ isRange }) => ({
        display: "block",
        padding: 16,
        "&.DatePicker--interactionDisabled .DayPicker-Day": {
            cursor: "default",
        },
        "& .DayPicker-wrapper": {
            position: "relative",
            flexDirection: "row",
            userSelect: "none",
            outline: "none",
            border: "none",
        },
        "& .DayPicker-Months": {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
        },
        "& .DayPicker-Month": {
            display: "table",
            userSelect: "none",
        },
        "& .DayPicker-Caption": {
            display: "table-caption",
            textAlign: "center",
            marginBottom: 16,
            "& select": Object.assign({ padding: "6px 24px 6px 8px", height: "100%", position: "relative", appearance: "none", border: "none", outline: "none", background: "none", cursor: "pointer", zIndex: 10 }, typography.supportedTags.h4),
            "& svg": {
                position: "absolute",
                zIndex: 1,
                right: 0,
            },
        },
        "& .DayPicker-Weekdays": {
            display: "table-header-group",
        },
        "& .DayPicker-WeekdaysRow, & .DayPicker-Week": {
            display: "table-row",
        },
        "& .DayPicker-Body": {
            display: "table-row-group",
        },
        "& .DayPicker-Day": {
            position: "relative",
            display: "table-cell",
            verticalAlign: "middle",
            textAlign: "center",
            cursor: "pointer",
            outline: "none",
            width: 40,
            height: 32,
            "&:hover, &--selected.DayPicker-Day--start, &--selected.DayPicker-Day--end": {
                background: isRange ? theme.palette.calendar.periodSelected : "",
                "& span": {
                    color: `${theme.palette.text.onColor} !important`,
                },
                "& span::after": {
                    backgroundColor: `${theme.palette.text.onColor} !important`,
                },
            },
            "&:hover": {
                borderRadius: 4,
                background: `${theme.palette.calendar.periodHover} !important`,
            },
            "&--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end)": {
                borderRadius: isRange ? 0 : 4,
                background: isRange
                    ? theme.palette.calendar.inPeriod
                    : theme.palette.calendar.periodSelected,
                "& span": {
                    color: !isRange
                        ? theme.palette.text.onColor
                        : theme.palette.text.primary,
                },
                "& span::after": {
                    backgroundColor: !isRange
                        ? theme.palette.text.onColor
                        : theme.palette.calendar.today,
                },
            },
            "&--selected.DayPicker-Day--start": {
                borderRadius: "4px 0 0 4px",
            },
            "&--selected.DayPicker-Day--end": {
                borderRadius: "0 4px 4px 0",
            },
            "&--selected.DayPicker-Day--start.DayPicker-Day--end": {
                borderRadius: 4,
            },
            "&--outside span": {
                color: theme.palette.text.disable,
                cursor: "default",
            },
            "&--today span:after": {
                position: "absolute",
                bottom: 4,
                left: "calc(50% - 16px/2)",
                display: "block",
                content: "''",
                width: 16,
                height: 2,
                borderRadius: 4,
                backgroundColor: theme.palette.calendar.today,
            },
        },
    }),
    weekday: {
        display: "table-cell",
        width: 40,
        height: 16,
        textAlign: "center",
    },
}));
//# sourceMappingURL=index.js.map